import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Breadcrumbs from './components/Breadcrumbs'
import ErrorBoundary from './components/ErrorBoundary'
import Home from './pages/Home'
import TrailersPage from './pages/TrailersPage'
import AluminumTrailersPage from './pages/AluminumTrailersPage'
import VentureTrailersPage from './pages/VentureTrailersPage'
import GalvanizedTrailersPage from './pages/GalvanizedTrailersPage'
import BunkTrailersPage from './pages/BunkTrailersPage'
import RollerTrailersPage from './pages/RollerTrailersPage'
import PWCTrailersPage from './pages/PWCTrailersPage'
import CommanderTrailersPage from './pages/CommanderTrailersPage'
import PontoonTrailersPage from './pages/PontoonTrailersPage'
import SkiffTrailersPage from './pages/SkiffTrailersPage'
import AccessoriesPage from './pages/AccessoriesPage'
import TipsPage from './pages/TipsPage'
import AboutPage from './pages/AboutPage'
import ContactPage from './pages/ContactPage'
import AdminPage from './pages/AdminPage'
import InventoryPage from './pages/InventoryPage'
import CheckTirePressurePage from './pages/blog/CheckTirePressurePage'
import WheelBearingsPage from './pages/blog/WheelBearingsPage'
import SafetyChainsPage from './pages/blog/SafetyChainsPage'
import TrailerLightInspectionPage from './pages/blog/TrailerLightInspectionPage'
import TongueWeightGuidePage from './pages/blog/TongueWeightGuidePage'
import SaltwaterMaintenancePage from './pages/blog/SaltwaterMaintenancePage'
import WinterizingTrailerPage from './pages/blog/WinterizingTrailerPage'
import LoadingBoatPage from './pages/blog/LoadingBoatPage'
import BrakeMaintenancePage from './pages/blog/BrakeMaintenancePage'
import ChoosingTrailerPage from './pages/blog/ChoosingTrailerPage'
import TroubleshootingPage from './pages/blog/TroubleshootingPage'
import NotFoundPage from './pages/NotFoundPage'
import './App.css'

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          <Routes>
            {/* Admin route without header/footer */}
            <Route path="/admin" element={<AdminPage />} />
          
          {/* Regular routes with header/footer */}
          <Route path="/*" element={
            <>
              <Header />
              <Breadcrumbs />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/trailers" element={<TrailersPage />} />
                <Route path="/trailers/aluminum" element={<AluminumTrailersPage />} />
                <Route path="/trailers/venture" element={<VentureTrailersPage />} />
                <Route path="/trailers/galvanized" element={<GalvanizedTrailersPage />} />
                <Route path="/trailers/bunk" element={<BunkTrailersPage />} />
                <Route path="/trailers/roller" element={<RollerTrailersPage />} />
                <Route path="/trailers/pwc" element={<PWCTrailersPage />} />
                <Route path="/trailers/commander" element={<CommanderTrailersPage />} />
                <Route path="/trailers/pontoon" element={<PontoonTrailersPage />} />
                <Route path="/trailers/skiff" element={<SkiffTrailersPage />} />
                <Route path="/trailers/accessories" element={<AccessoriesPage />} />
                <Route path="/inventory" element={<InventoryPage />} />
                <Route path="/tips" element={<TipsPage />} />
                <Route path="/tips/check-tire-pressure-monthly" element={<CheckTirePressurePage />} />
                <Route path="/tips/wheel-bearing-maintenance" element={<WheelBearingsPage />} />
                <Route path="/tips/safety-chains-guide" element={<SafetyChainsPage />} />
                <Route path="/tips/trailer-light-inspection" element={<TrailerLightInspectionPage />} />
                <Route path="/tips/tongue-weight-guide" element={<TongueWeightGuidePage />} />
                <Route path="/tips/saltwater-maintenance" element={<SaltwaterMaintenancePage />} />
                <Route path="/tips/winterizing-trailer" element={<WinterizingTrailerPage />} />
                <Route path="/tips/loading-boat-correctly" element={<LoadingBoatPage />} />
                <Route path="/tips/brake-maintenance" element={<BrakeMaintenancePage />} />
                <Route path="/tips/choosing-right-trailer" element={<ChoosingTrailerPage />} />
                <Route path="/tips/troubleshooting-guide" element={<TroubleshootingPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
              <Footer />
            </>
          } />
          </Routes>
        </div>
      </Router>
    </ErrorBoundary>
  )
}

export default App